const scheduledServicesCalendarHeader = {
  title: "Calendário Serviços Agendados",
  filters: "Filtros",
  clear: "LIMPAR",
};

export default scheduledServicesCalendarHeader;
